export const chartColumns = () => [
  // {
  //   type: 'seq', //
  //   title: '序号',
  // },
  {
    field: 'hwType', //
    title: '货物类型',
  },
  {
    field: 'hwCategory', //
    title: '货物品类',
  },
  {
    field: 'hwSpecifications',
    title: '货物规格/型号',
  },
  {
    field: 'hwUnit',
    title: '货物单位',
  },
  // {
  //   field: 'warehouseAmount',
  //   title: '库存总量/重量',
  // },
  { field: 'enterAmount', title: '入库数' },
  { field: 'toAmount', title: '出库数' },
  {
    field: 'remarks',
    title: '备注',
  },
];
